import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "header", "body"]

  connect() {
    const hasHash = window.location.hash !== ''
    const isTargetedItem = window.location.hash === `#${this.element.id}`
    const isExpandedByDefault = this.bodyTarget.style.display === 'block'

    if (hasHash) {
      // If there's a hash in the URL, only expand if it matches this item
      if (isTargetedItem) {
        this.expand()
      } else {
        this.collapse()
      }
    } else if (isExpandedByDefault) {
      // Keep default expanded state only if no hash is present
      this.expand()
    }
  }

  toggle(event) {
    var faqBody = this.bodyTarget
    var faqHeader = this.headerTarget

    if (faqBody.style['display'] != 'none') {
      var slideDir = 'slideUp';
      faqHeader.classList.remove("expanded");
    } else {
      var slideDir = 'slideDown';
      faqHeader.classList.add("expanded");
    }
    Velocity(faqBody, slideDir, {duration: 400, easing: 'ease-in-out' })
  }

  expand() {
    this.bodyTarget.style.display = 'block'
    this.headerTarget.classList.add("expanded")
  }

  collapse() {
    this.bodyTarget.style.display = 'none'
    this.headerTarget.classList.remove("expanded")
  }
}
